import { render } from "./AppealForm.vue?vue&type=template&id=cb4ada0c"
import script from "./AppealForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AppealForm.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/jbh/achievementManage/accountAppeal/AppealForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "cb4ada0c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cb4ada0c', __exports__)) {
    console.log('reload')
    api.reload('cb4ada0c', __exports__)
  }
  
  module.hot.accept("./AppealForm.vue?vue&type=template&id=cb4ada0c", () => {
    console.log('re-render')
    api.rerender('cb4ada0c', render)
  })

}


export default __exports__